<template>
  <div>
    <!-- <div id="pieEcharts" style="width: 600px;height:400px;"></div> -->
    <div class="charts">
      <div id="pieChart" style="width: 500px;height:400px;">1111</div>
      <div id="lineChart" style="width: 500px;height:400px;"></div>
    </div>
    <div class="charts as">
      <div>本月经营利润总计:5464654元</div>
      <div>过去半年月度经营性利润统计</div>
    </div>
    <template>
      <div class="block">
        <span class="demonstration">默认</span>
        <el-date-picker
          v-model="chooseDate"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
        ></el-date-picker>
      </div>
    </template>
    <vue-qr text="weixin://wxpay/bizpayurl?pr=zRDAjkg" :size="200"></vue-qr>
    <!-- <avue-echart-pie :theme="theme" :option="pieOption" :data="data" width="1000"></avue-echart-pie> -->
  </div>
</template>

<script src="https://cdnjs.cloudflare.com/ajax/libs/echarts/4.3.0/echarts.js"></script>
<script>
import vueQr from "vue-qr";
export default {
  name: "echarts",
  data() {
    return {
      chooseDate: "",
      data: ["七月", "八月", "九月", "十月", "十一月", "十二月"]
    };
  },
  components: {
    vueQr
  },
  mounted() {
    console.log(this);
    let data = this.data;
    console.log(document.getElementById("pieChart"));
    console.log(document.getElementById("lineChart"));
    // 基于准备好的dom，初始化echarts实例
    var pieChart = echarts.init(document.getElementById("pieChart"));
    var lineChart = echarts.init(document.getElementById("lineChart"));
    // 指定图表的配置项和数据
    var lineOption = {
      xAxis: {
        type: "category",
        data: data
      },
      yAxis: {
        type: "value"
      },
      series: [
        {
          data: [820, 932, 901, 934, 1290, 1330],
          type: "line",
          label: {
            normal: {
              show: true, //数值显示
              position: "top", //显示位置
              textStyle: {
                color: "#000"
              }
            }
          }
        }
      ]
    };

    var pieOption = {
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b} : {c} ({d}%)"
      },
      legend: {
        orient: "",
        top: "middle",
        bottom: 10,
        left: "left",
        data: ["收入总计:123123", "支出总计:123123"]
      },
      series: [
        {
          name: "数据来源",
          type: "pie",
          radius: "50%",
          center: ["55%", "50%"],
          selectedMode: "single",
          data: [
            { value: 634, name: "收入总计:123123" },
            { value: 735, name: "支出总计:123123" }
          ],
          label: {
            normal: {
              textStyle: {
                color: "rgba(255, 255, 255, 0)"
              }
            }
          },
          labelLine: {
            normal: {
              lineStyle: {
                color: "rgba(255, 255, 255, 0)"
              },
              smooth: 0.2,
              length: 10,
              length2: 20
            }
          }
        }
      ]
    };

    // 使用刚指定的配置项和数据显示图表。
    pieChart.setOption(pieOption);
    lineChart.setOption(lineOption);
  }
};
</script>

<style>
.charts {
  display: flex;
  background: #fff;
  margin: 1px 10px;
}
.as {
  position: relative;
  top: -1px;
  display: flex;
  justify-content: space-around;
}
</style>